(ns common.schema.entities.survey.survey-question.permissions
  (:require
   [common.features.plan :as plan]
   [common.schema.entities.permissions :as entity-permissions]))

(defn read-permissions?
  [{:keys [tenant role tenant-plan]}]
  (plan/available :feature/surveys tenant role tenant-plan))

;; TODO: we need explicit delete permissions to be configured for non activity entity types
(defn disable-permissions?
  [ctx]
  (entity-permissions/disable-when-no-write-permission ctx))
